import type {
  CompanySearchResult,
  MergedAccountView,
} from "@sales-ops-amplify/shared";

/** Workspace account URL segment — partition id only (never a name slug). */
export function workspaceAccountDetailId(
  row:
    | Pick<CompanySearchResult, "accountId">
    | Pick<MergedAccountView, "accountId">,
): string | undefined {
  return row.accountId?.trim() || undefined;
}

export function accountDetailPath(
  row:
    | Pick<CompanySearchResult, "accountId">
    | Pick<MergedAccountView, "accountId">,
): string | undefined {
  const id = workspaceAccountDetailId(row);
  return id ? `/user/accounts/${encodeURIComponent(id)}` : undefined;
}
